import { useMemo } from 'react';

import { demoWoopWorkloadDetails } from '@cast/fixtures';
import { OptimizationWorkloadDetailsResponse } from '@cast/types';

import { useIsWoopDemoMode } from 'features/workload-optimization';
import {
  UseWorkloadQueryArgs,
  useWorkloadQuery,
} from 'hooks/queries/workload-optimization';
import { useDataOrFixture } from 'hooks/useDataOrFixture';

export const useWoopWorkload = (queryArgs: UseWorkloadQueryArgs) => {
  const isWoopDemoMode = useIsWoopDemoMode();

  const queryResult = useWorkloadQuery({
    ...queryArgs,
    enabled: !isWoopDemoMode && queryArgs.enabled,
  });

  const demoWorkloadsFixture = useMemo(
    () => () =>
      demoWoopWorkloadDetails().then((fixture) => {
        const workloadId = queryArgs.workloadId;
        const workloadDetails = fixture.find(
          ({ workload }) => workload.id === workloadId
        );
        return {
          ...workloadDetails,
          loadedLength: queryResult.data?.loadedLength,
        } as OptimizationWorkloadDetailsResponse & {
          loadedLength?: number | undefined;
        };
      }),
    [queryArgs.workloadId, queryResult.data?.loadedLength]
  );

  const workloadDataOrFixture = useDataOrFixture(
    queryResult.data,
    demoWorkloadsFixture,
    isWoopDemoMode
  );

  return { ...queryResult, ...workloadDataOrFixture };
};
